import { useLanguage } from "../i18n";

const WORDS = {
  tr: ["Sürdürülebilir Tarım", "Küresel İhracat", "Premium Kalite", "Soğuk Zincir"],
  en: ["Sustainable Agriculture", "Global Export", "Premium Quality", "Cold Chain"],
  ru: ["Устойчивое земледелие", "Глобальный экспорт", "Премиальное качество", "Холодовая цепь"],
};

export const GiantMarquee = () => {
  const { lang } = useLanguage();
  const words = WORDS[lang] || WORDS.tr;

  return (
    <section
      data-testid="giant-marquee"
      className="relative overflow-hidden border-y border-white/5 bg-[#07170f] py-10"
    >
      <div className="marquee-track items-center" style={{ "--marquee-duration": "60s" }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {words.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="giant-word">{w}</span>
                <span className="giant-word giant-word-sep">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
